export const aboutSection = document.querySelector('.about-carousel-section');
export const introSection = document.querySelector('.intro-carousel-section');
export const carouselOffSection = document.querySelector('#carousel-off-section');
